import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useAuth } from "contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";

const LogIn = () => {
  const emailRef = useRef();
  const pwdRef = useRef();
  const { login, currentUser } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      await login(emailRef.current.value, pwdRef.current.value);
      history.push("/admin");
    } catch {
      setError("Failed to log in");
    }
    setLoading(false);
  };

  return (
    <>
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">Log In</h2>
          {currentUser?.email}
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" required ref={emailRef}></Form.Control>
            </Form.Group>
            <Form.Group id="pwd">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                required
                ref={pwdRef}
              ></Form.Control>
            </Form.Group>

            <Button disabled={loading} className="w-100 mt-4" type="submit">
              Log In
            </Button>
          </Form>

          <div className="w-100 text-center mt-3">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2">
        {/* Need an account ? <Link to="/signup">Sign Up</Link> */}
      </div>
      <div className="w-100 text-center mt-2">
        Pilot Check-in ? <Link to="/pilot">Check In</Link>
      </div>
    </>
  );
};

export default LogIn;
